var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 46 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "audioSVG",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2629 23.1279C44.3347 23.1279 45.2 24.0109 45.2 25.0989C45.2 37.1667 36.0964 47.1013 24.5379 48.1088L24.5371 54.5291C24.5371 55.617 23.6693 56.5 22.6 56.5C21.5307 56.5 20.6629 55.617 20.6629 54.5291L20.6646 48.109C9.10492 47.1027 0 37.1676 0 25.0989C0 24.0109 0.86784 23.1279 1.93714 23.1279C3.00903 23.1279 3.87429 24.0109 3.87429 25.0989C3.87429 35.6578 12.2737 44.2511 22.6 44.2511C32.9263 44.2511 41.3257 35.6578 41.3257 25.0989C41.3257 24.0109 42.1936 23.1279 43.2629 23.1279ZM22.6 0C29.4523 0 35.0287 5.69467 35.0287 12.6954V25.015C35.0287 32.0132 29.4523 37.7078 22.6 37.7078C15.7477 37.7078 10.1713 32.0132 10.1713 25.015V12.6954C10.1713 5.69467 15.7477 0 22.6 0ZM22.6 3.94186C17.8837 3.94186 14.0456 7.86795 14.0456 12.6954V25.015C14.0456 29.8373 17.8837 33.766 22.6 33.766C27.3163 33.766 31.1544 29.8373 31.1544 25.015V12.6954C31.1544 7.86795 27.3163 3.94186 22.6 3.94186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.5ca269fb69e50637b3ac48cabbee165e.svg";
export { ForwardRef as ReactComponent };